import ListingInfo from './ListingInfo'

export default ListingInfo
